namespace InvData.Util {
  export function updatePropertyValues(property: any, newValue: Array<any>, fromDayId?: number) {
    const propTypeIds = InvData.PropertyTypeIds;

    property.value = {};
    property.value.from = fromDayId;
    // Set up valueStrings/HtmlList.
    switch (property.property.propertyTypeId) {
      case propTypeIds["String"]:
      case propTypeIds["Html"]:
      case propTypeIds["Url"]:
      case propTypeIds["LongText"]:
        property.value.s = newValue;
        property.valueStrings = property.value.s;
        break;

      case propTypeIds["Boolean"]:
        property.value.b = newValue;
        property.valueStrings = property.value.b.map(function (b) {
          return b ? "Yes" : "No";
        });
        break;

      case propTypeIds["Integer"]:
        property.value.i = newValue;
        property.valueStrings = property.value.i.map(function (i) {
          return i.toString();
        });
        break;

      case propTypeIds["Decimal"]:
      case propTypeIds["Currency"]:
        property.value.d = newValue;
        property.valueStrings = property.value.d.map(function (d) {
          return d.toString();
        });
        break;

      case propTypeIds["Date"]:
        property.value.dt = newValue;
        property.valueStrings = property.value.dt.map(function (dayId) {
          return InvData.Util.DateIndexHelper.formatDateIndexAsDateString(dayId);
        });
        break;

      case propTypeIds["TagRef"]: {
        property.value.t = newValue;
        property.valueStrings = property.value.t
          .filter((tag) => typeof tag !== "number")
          .map((tag) => tag.tagLabel);

        property.value.t = property.value.t.map((tag) =>
          typeof tag === "number" ? tag : tag.tagId
        );
        break;
      }

      case propTypeIds["EntityRef"]: {
        property.value.e = newValue;
        property.valueStrings = property.value.e
          .filter((entity) => typeof entity !== "number")
          .map((entity) => entity.label);

        property.value.e = property.value.e.map((entity) =>
          typeof entity === "number" ? entity : entity.entityId
        );
        break;
      }

      case propTypeIds["InvestmentRef"]: {
        property.value.r = newValue;
        property.valueStrings = property.value.r
          .filter((investment) => typeof investment !== "number")
          .map((investment) => investment.label);

        property.value.r = property.value.r.map((inv) =>
          typeof inv === "number" ? inv : inv.investmentId
        );
        break;
      }

      case propTypeIds["NoteRef"]:
      case propTypeIds["ContactRef"]:
      case propTypeIds["TransactionRef"]: {
        property.value.r = newValue;
        property.valueStrings = property.value.r
          .filter((resource) => typeof resource !== "number")
          .map((resource) => resource.label);

        property.value.r = property.value.r.map((resource) =>
          typeof resource === "number" ? resource : resource.resourceId
        );
        break;
      }

      case propTypeIds["UserRef"]: {
        property.value.i = newValue;
        property.valueStrings = property.value.i
          .filter((user) => typeof user !== "number")
          .map((user) => `${user.fullName} - ${user.primaryEmail}`);

        property.value.i = property.value.i.map((user) =>
          typeof user === "number" ? user : user.userId
        );
        break;
      }
    }
  }

  export function GetDataTypeByPropertyType(propertyTypeId: number): string {
    var propTypeIds = InvData.PropertyTypeIds;

    if (propertyTypeId === propTypeIds.String ||
      propertyTypeId === propTypeIds.LongText ||
      propertyTypeId === propTypeIds.Url) {
      return "string";
    }
    else if (propertyTypeId === propTypeIds.Integer ||
      propertyTypeId === propTypeIds.Decimal ||
      propertyTypeId === propTypeIds.Currency) {
      return "number";
    }
    else if (propertyTypeId === propTypeIds.Boolean) {
      return "bool";
    }
    else if (propertyTypeId === propTypeIds.Date) {
      return "dayId";
    }
    else if (propertyTypeId === propTypeIds.Html) {
      return "html";
    }
    else if (propertyTypeId === propTypeIds.TagRef) {
      return "tagId";
    }
    else if (propertyTypeId === propTypeIds.EntityRef) {
      return "entityId";
    }
    else if (propertyTypeId === propTypeIds.InvestmentRef) {
      return "investment.resourceId";
    }
    else if (propertyTypeId === propTypeIds.ManagerRef) {
      return "string";
    }
    else if (propertyTypeId === propTypeIds.ContactRef) {
      return "contact.resourceId";
    }
    else if (propertyTypeId === propTypeIds.NoteRef) {
      return "note.resourceId";
    }
    else if (propertyTypeId === propTypeIds.TransactionRef) {
      return "tx.resourceId";
    }
    else if (propertyTypeId === propTypeIds.UserRef) {
      return "userId";
    }
  }

  export function TouchUpValueStringByPropertyType(
    propertyTypeId: number,
    propValue: any) {

    var propTypeIds = InvData.PropertyTypeIds;
    switch (propertyTypeId) {
      case propTypeIds["String"]:
      case propTypeIds["Url"]:
      case propTypeIds["Html"]:
      case propTypeIds["LongText"]:
        if (propValue.value.s) {
          propValue.valueStrings = propValue.value.s;
        }
        break;

      case propTypeIds["Boolean"]:
        if (propValue.value.b) {
          propValue.valueStrings = propValue.value.b.map(
            function (b) {
              return b ? "Yes" : "No"
            });
        }
        break;

      case propTypeIds["Integer"]:
        if (propValue.value.i) {
          propValue.valueStrings = propValue.value.i.map(
            function (i) {
              return i.toString();
            });
        }
        break;

      case propTypeIds["Date"]:
        if (propValue.value.dt) {
          propValue.valueStrings = propValue.value.dt.map(
            function (dayId) {
              return InvData.DayId.format(dayId as number);
            });
        }
    }
  }
  export function updatePropertyValuesWithModelEnv(item: any, modelEnv: ModelEnvironment) {
    const propTypeIds = InvData.PropertyTypeIds;
    switch (item.property.propertyTypeId) {
      case propTypeIds["String"]:
      case propTypeIds["Html"]:
      case propTypeIds["Url"]:
      case propTypeIds["LongText"]:
        item.valueStrings = item.value.s;
        item.rawValue = item.value.s;
        break;

      case propTypeIds["Boolean"]:
        if (item?.value?.b) {
          item.valueStrings = item.value.b.map(
            function (b) {
              return b ? "Yes" : "No";
            });
          item.rawValue = item.value.b;
        }
        else {
          item.valueStrings = [];
          item.rawValue = [];
        }
        break;

      case propTypeIds["Integer"]:
        if (item.value.i) {
          item.valueStrings = item.value.i.map(
            function (i) {
              return i.toString();
            });
        }
        item.rawValue = item.value.i;
        break;

      case propTypeIds["Decimal"]:
      case propTypeIds["Currency"]:
        if (item.value.d) {
          item.valueStrings = item.value.d.map(
            function (d) {
              return d.toString();
            });
        }
        item.rawValue = item.value.d;
        break;

      case propTypeIds["Date"]:
        if (item.value.dt) {
          item.valueStrings = item.value.dt.map(
            function (dayId) {
              return InvData.Util.DateIndexHelper.formatDateIndexAsDateString(dayId);
            });
        }
        item.rawValue = item.value.dt;
        break;

      case propTypeIds["TagRef"]:
        if (item.value.t) {
          item.valueStrings = item.value.t.map(
            function (tagId) {
              var tagSet = modelEnv.tagSets.tryGetById(item.property.tagRefTagSetId);
              var tag = tagSet.tryGetTagById(tagId);

              if (typeof tag === "undefined" || tag === null) {
                return "Tag Id " + tagId + " not found";
              }

              return tag.label;
            });
        }
        item.rawValue = item.value.t;
        break;

      case propTypeIds["EntityRef"]:
        if (item.value.e) {
          item.valueStrings = item.value.e.map(
            function (entityId) {
              var entity = modelEnv.getEntityById(entityId);

              if (typeof entity === "undefined" || entity === null) {
                return "Entity Id " + entityId + " not found";
              }
              return entity.label;
            });
        }
        item.rawValue = item.value.e;
        break;

      case propTypeIds["InvestmentRef"]:
        if (item.value.r) {
          item.valueStrings = item.value.r.map(
            function (invId) {
              var investment = modelEnv.tryGetInvestmentByResourceId(invId);

              if (typeof investment === "undefined" || investment === null) {
                return "Investment Id " + invId + " not found";
              }

              return investment.label;
            });
        }
        item.rawValue = item.value.r;
        break;

      case propTypeIds["NoteRef"]:
      case propTypeIds["ContactRef"]:
      case propTypeIds["TransactionRef"]:
        item.valueStrings = item.value.r;
        item.rawValue = item.value.r;
        break;

      case propTypeIds["UserRef"]:
        if (item.value.i) {
          item.valueStrings = item.value.i.map(
            function (userId) {
              var user = modelEnv.users.idToItemMap[userId];
              if (typeof user === "undefined" || user === null) {
                return "User Id " + userId + " not found";
              }

              return user.fullName;
            });
        }
        item.rawValue = item.value.i;
        break;
    }
  }
}